import {
  UserCheck,
  Building2,
  Network,
  KeyRound,
  ScrollText,
  SlidersHorizontal,
  Boxes,
  type LucideIcon,
} from 'lucide-react';

export interface BasicFeatureMeta {
  id: string;
  slug: string;
  label: string;
  singular: string;
  description: string;
  icon: LucideIcon;
  iconName: string;
  route: string;
}

export const BASIC_FEATURES: Record<string, BasicFeatureMeta> = {
  contacts: {
    id: 'core.basic.contacts',
    slug: 'contacts',
    label: 'Contacts',
    singular: 'Contact',
    description: 'Individuals, stakeholders, leads, and customer representatives.',
    icon: UserCheck,
    iconName: 'user-check',
    route: '/core/basic/contacts',
  },
  companies: {
    id: 'core.basic.companies',
    slug: 'companies',
    label: 'Companies',
    singular: 'Company',
    description: 'Business accounts, client companies, suppliers, and partner entities.',
    icon: Building2,
    iconName: 'building-2',
    route: '/core/basic/companies',
  },
  relationships: {
    id: 'core.basic.relationships',
    slug: 'relationships',
    label: 'Relationships',
    singular: 'Relationship',
    description: 'Network graph connections, employment links, and company roles.',
    icon: Network,
    iconName: 'network',
    route: '/core/basic/relationships',
  },
  roles: {
    id: 'core.admin.roles',
    slug: 'roles',
    label: 'Roles & Permissions',
    singular: 'Role',
    description: 'RBAC access roles, security scopes, and operational privileges.',
    icon: KeyRound,
    iconName: 'key-round',
    route: '/core/admin/roles',
  },
  auditLog: {
    id: 'core.admin.audit-log',
    slug: 'audit-log',
    label: 'Audit Log',
    singular: 'Audit Entry',
    description: 'Cryptographically chained, immutable audit ledger of all mutations.',
    icon: ScrollText,
    iconName: 'scroll-text',
    route: '/core/admin/audit-log',
  },
  customFields: {
    id: 'core.basic.custom-fields',
    slug: 'custom-fields',
    label: 'Custom Fields',
    singular: 'Custom Field',
    description: 'Tenant-scoped dynamic schema fields with runtime validation.',
    icon: SlidersHorizontal,
    iconName: 'sliders-horizontal',
    route: '/core/basic/custom-fields',
  },
  customObjects: {
    id: 'core.basic.custom-objects',
    slug: 'custom-objects',
    label: 'Custom Objects',
    singular: 'Custom Object',
    description: 'User-defined bespoke entity types, records, and schema catalogs.',
    icon: Boxes,
    iconName: 'boxes',
    route: '/core/basic/custom-objects',
  },
};

// Aliases for slug-based indexing
BASIC_FEATURES['custom-fields'] = BASIC_FEATURES.customFields;
BASIC_FEATURES['custom-objects'] = BASIC_FEATURES.customObjects;
BASIC_FEATURES['audit-log'] = BASIC_FEATURES.auditLog;

